import(/* webpackMode: "eager" */ "/home/runner/work/mercury-fem/mercury-fem/src/app/global-error.tsx");
